export enum EnumContactJob {
  CLEVEL_BOARD = "C-Level / Diretoria",
  MANAGER_OR_COORDINATOR = "Gerente / Coordenador(a)",
  ANALYST = "Analista",
  INTERN = "Estagiário(a)",
  OTHER = "Outros",
}
